/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getAllProcessingGroups } from '../fn/processing-group-controller/get-all-processing-groups';
import { GetAllProcessingGroups$Params } from '../fn/processing-group-controller/get-all-processing-groups';
import { ResponseProcessingGroupDto } from '../models/response-processing-group-dto';

@Injectable({ providedIn: 'root' })
export class ProcessingGroupControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllProcessingGroups()` */
  static readonly GetAllProcessingGroupsPath = '/processinggroups';

  /**
   * List all available processing groups
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllProcessingGroups()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllProcessingGroups$Response(params?: GetAllProcessingGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseProcessingGroupDto>> {
    return getAllProcessingGroups(this.http, this.rootUrl, params, context);
  }

  /**
   * List all available processing groups
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllProcessingGroups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllProcessingGroups(params?: GetAllProcessingGroups$Params, context?: HttpContext): Observable<ResponseProcessingGroupDto> {
    return this.getAllProcessingGroups$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseProcessingGroupDto>): ResponseProcessingGroupDto => r.body)
    );
  }

}
